import React, { useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom';


export default function NewMission() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/job-offer');
    };

    return (
        <div className="new-mission-widget">
            <div >
                <p>Nouvelle mission</p>
                <h3>Commander une nouvelle mission</h3>
            </div>
            <div >
                <p>Envoyez-nous vos besoins en quelques clics</p>
                <button onClick={handleClick}>Rechercher une nouvelle mission</button>
            </div>
        </div>

    );
}